import { boot } from 'quasar/wrappers'
import InfiniteLoading from 'v3-infinite-loading'
import 'v3-infinite-loading/lib/style.css'

export default boot(({ app }) => {
  app.component('infinite-loading', InfiniteLoading)
})
